<template>
	<div class="flex flex-col items-start gap-0.5">
		<div v-if="props.label" class="pl-1 text-sm">
			{{ props.label }}
		</div>
		<ion-select
			v-bind="$attrs"
			:label="undefined"
			:toggle-icon="caretDownOutline"
		>
			<slot />
		</ion-select>
		<div v-if="props.error" class="pl-1 text-xs text-red-600">
			{{ props.error }}
		</div>
	</div>
</template>

<script setup lang="ts">
	import { IonSelect } from "@ionic/vue";
	import { caretDownOutline } from "ionicons/icons";

	interface SgSelectProps {
		label?: string;
		error?: string;
	}
	const props = defineProps<SgSelectProps>();

	defineOptions({
		inheritAttrs: true,
	});
</script>

<style scoped>
	ion-select {
		--background: #eee;
		--padding-start: 0.5rem;
		--padding-end: 0.5rem;
		--border-radius: 0.5rem;
		--placeholder-opacity: 0.5;
		min-height: 2.6rem;
	}
</style>
